"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCharityNumberFromRegistryEinBn = exports.normalizeCharityNumberForStorage = exports.formatEIN = exports.formatCharityNumberForDisplay = exports.formatAuAbn = exports.isEinOrCharityNumberValid = exports.isIeCroNumberValid = exports.isAuAbnValid = exports.isGbCrnValid = exports.isUsEinValid = exports.getOnboardingCharityNumberStepKey = exports.getCharityNumberOrEinFieldConfig = exports.getOrganizationTypeFromRegistryMatch = exports.askForHmrc = exports.getVerificationTaxIdLabelKey = exports.countryHasEIN = exports.getEINPlaceholder = void 0;
const enums_1 = require("../../enums");
const country_1 = require("../enums/country");
const de_fiscal_1 = require("./de-fiscal");
const getEINPlaceholder = (country) => {
    if (country === country_1.OrganizationCountry.GreatBritain) {
        return "1234567";
    }
    if (country === country_1.OrganizationCountry.Australia) {
        return "12 345 678 901";
    }
    if (country === country_1.OrganizationCountry.Ireland) {
        return "123456";
    }
    if (country === country_1.OrganizationCountry.Germany) {
        return "VR 12345";
    }
    return undefined;
};
exports.getEINPlaceholder = getEINPlaceholder;
const countryHasEIN = (country) => {
    return country === country_1.OrganizationCountry.UnitedStates;
};
exports.countryHasEIN = countryHasEIN;
const getVerificationTaxIdLabelKey = (country) => {
    if (country === country_1.OrganizationCountry.UnitedStates) {
        return "US";
    }
    if (country === country_1.OrganizationCountry.Canada) {
        return "CA";
    }
    if (country === country_1.OrganizationCountry.GreatBritain) {
        return "GB";
    }
    return "other";
};
exports.getVerificationTaxIdLabelKey = getVerificationTaxIdLabelKey;
const askForHmrc = (country, organizationType) => {
    return country === country_1.OrganizationCountry.GreatBritain && organizationType === enums_1.OrganizationType.Charity;
};
exports.askForHmrc = askForHmrc;
const getOrganizationTypeFromRegistryMatch = (nonprofit) => nonprofit.country === country_1.OrganizationCountry.GreatBritain ||
    nonprofit.country === country_1.OrganizationCountry.Germany ||
    nonprofit.subsectionCode === 3
    ? enums_1.OrganizationType.Charity
    : enums_1.OrganizationType.Other501C;
exports.getOrganizationTypeFromRegistryMatch = getOrganizationTypeFromRegistryMatch;
const getCharityNumberOrEinFieldConfig = (country, type, deLegalForm) => {
    const isCharityType = type === enums_1.OrganizationType.Charity || type === enums_1.OrganizationType.Other501C;
    if (country === country_1.OrganizationCountry.Canada) {
        return { display: isCharityType, isRequired: isCharityType };
    }
    if (country === country_1.OrganizationCountry.Australia) {
        return { display: true, isRequired: true };
    }
    if (country === country_1.OrganizationCountry.GreatBritain) {
        return { display: true, isRequired: false };
    }
    if (country === country_1.OrganizationCountry.Ireland) {
        return { display: true, isRequired: false };
    }
    if (country === country_1.OrganizationCountry.Germany) {
        const hasRegisterNumber = Boolean((0, de_fiscal_1.getDeRegisterType)(deLegalForm));
        return { display: hasRegisterNumber, isRequired: hasRegisterNumber };
    }
    return { display: true, isRequired: isCharityType };
};
exports.getCharityNumberOrEinFieldConfig = getCharityNumberOrEinFieldConfig;
const getOnboardingCharityNumberStepKey = (country) => country === country_1.OrganizationCountry.Germany
    ? "bank.onboardingStepper.step.zeffy.vereinsregisternummer"
    : "bank.onboardingStepper.step.zeffy.ein";
exports.getOnboardingCharityNumberStepKey = getOnboardingCharityNumberStepKey;
const isCanadianCharityNumberValid = (ein) => {
    if (!ein) {
        return true;
    }
    return /^\d{9}RR\d{4}$/.test(ein);
};
const isUsEinValid = (ein) => {
    if (!ein) {
        return true;
    }
    return /^\d{2}-\d{7}$/.test(ein) || /^\d{9}$/.test(ein);
};
exports.isUsEinValid = isUsEinValid;
const isGbCrnValid = (ein) => {
    if (!ein) {
        return true;
    }
    // UK Company/Charity number formats:
    // - England/Wales: 5-8 digits (e.g., 1234567, 12345678)
    // - Scotland: SC + 6 digits — Companies House CRNs (e.g., SC866276) and OSCR (e.g., SC048927 = SC + 048927)
    // - Northern Ireland: 6 digits with optional NIC prefix and check digit (e.g., 100001, NIC100001, NIC100001-1)
    return /^\d{5,8}$/.test(ein) || /^SC\d{6}$/i.test(ein) || /^(NIC)?\d{6}(-\d)?$/i.test(ein);
};
exports.isGbCrnValid = isGbCrnValid;
const isAuAbnValid = (ein) => {
    if (!ein) {
        return true;
    }
    return /^\d{11}$/.test(ein);
};
exports.isAuAbnValid = isAuAbnValid;
const isIeCroNumberValid = (croNumber) => {
    if (!croNumber) {
        return true;
    }
    return /^\d{4,7}[A-Z]{0,2}$/i.test(croNumber.trim());
};
exports.isIeCroNumberValid = isIeCroNumberValid;
const charityNumberValidatorByCountry = {
    [country_1.OrganizationCountry.UnitedStates]: exports.isUsEinValid,
    [country_1.OrganizationCountry.Canada]: isCanadianCharityNumberValid,
    [country_1.OrganizationCountry.GreatBritain]: exports.isGbCrnValid,
    [country_1.OrganizationCountry.Australia]: exports.isAuAbnValid,
    [country_1.OrganizationCountry.Ireland]: exports.isIeCroNumberValid,
    [country_1.OrganizationCountry.Germany]: de_fiscal_1.isDeVereinsregisternummerValid,
};
const isEinOrCharityNumberValid = (ein, country, deLegalForm) => {
    if ((0, de_fiscal_1.usesDeFiscalFields)(country)) {
        return (0, de_fiscal_1.isDeRegisterNumberValid)(ein, deLegalForm);
    }
    const countryValidator = country ? charityNumberValidatorByCountry[country] : undefined;
    if (countryValidator) {
        return countryValidator(ein);
    }
    return ((0, exports.isUsEinValid)(ein) ||
        isCanadianCharityNumberValid(ein) ||
        (0, exports.isGbCrnValid)(ein) ||
        (0, exports.isAuAbnValid)(ein) ||
        (0, exports.isIeCroNumberValid)(ein) ||
        (0, de_fiscal_1.isDeVereinsregisternummerValid)(ein));
};
exports.isEinOrCharityNumberValid = isEinOrCharityNumberValid;
const formatAuAbn = (abn) => {
    const digits = abn?.replace(/\D/g, "");
    return digits?.length === 11
        ? `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`
        : abn;
};
exports.formatAuAbn = formatAuAbn;
const formatCharityNumberForDisplay = (country, charityNumber) => country === country_1.OrganizationCountry.Australia ? (0, exports.formatAuAbn)(charityNumber) : charityNumber;
exports.formatCharityNumberForDisplay = formatCharityNumberForDisplay;
const formatEIN = (ein) => ein && /^\d{9}$/.test(ein) ? `${ein.slice(0, 2)}-${ein.slice(2)}` : ein;
exports.formatEIN = formatEIN;
const normalizeCharityNumberForStorage = (country, charityNumber, deLegalForm) => (0, de_fiscal_1.usesDeFiscalFields)(country)
    ? (0, de_fiscal_1.getDeRegisterType)(deLegalForm)
        ? (0, de_fiscal_1.normalizeDeVereinsregisternummer)(charityNumber ?? "") || null
        : null
    : (0, exports.formatEIN)(charityNumber);
exports.normalizeCharityNumberForStorage = normalizeCharityNumberForStorage;
const getCharityNumberFromRegistryEinBn = (einBn) => einBn && !(0, de_fiscal_1.getDeZerIdFromEinBn)(einBn) ? einBn : undefined;
exports.getCharityNumberFromRegistryEinBn = getCharityNumberFromRegistryEinBn;
